export default __webpack_public_path__ + "00e79a1eabdbbce2ff8a2da94eeb7ff6.jpg";